export type AlertSeverity = 'info' | 'warning' | 'critical';

export interface Alert {
  id: string;
  type: string;
  symbol: string;
  title: string;
  body: string;
  severity: AlertSeverity;
  createdAt: string;
  readAt?: string;
  thesisId?: string;
  decisionId?: string;
}

export function currentNotificationPermission(): NotificationPermission {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
  return Notification.permission;
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  return Notification.requestPermission();
}

export function showBrowserNotification(alert: Alert): void {
  if (currentNotificationPermission() !== 'granted') return;
  try {
    const notification = new Notification(alert.title, {
      body: alert.body,
      tag: alert.id,
      silent: alert.severity === 'info',
    });
    window.setTimeout(() => notification.close(), 12_000);
  } catch {
    // Browser notification is best-effort; caller still has in-app toast fallback.
  }
}